import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FeelingResources } from "shared/request/myHealthyAdvantageApi";
import { ReassuranceScreen } from "../../../Views/SupportMoments/Components/ReassuranceScreen/ReassuranceScreen";
import { SUPPORT_OPTION_CONFIG, SupportOption } from "../../../Views/SupportMoments/enums/supportMoments/supportMoments";

export type SupportMomentsReassuranceContextType = {
  showReassurance: (option: SupportOption, resources?: FeelingResources[]) => void;
};

export const SupportMomentsReassuranceContext = createContext({} as SupportMomentsReassuranceContextType);

export const useSupportMomentsReassuranceContext = () => useContext(SupportMomentsReassuranceContext);

export const SupportMomentsReassuranceContextProvider = ({ children }: PropsWithChildren) => {
  const [option, setOption] = useState<SupportOption | null>(null);
  const resourcesRef = useRef<FeelingResources[] | undefined>(undefined);
  const navigate = useNavigate();

  const showReassurance = useCallback((option: SupportOption, resources?: FeelingResources[]) => {
    resourcesRef.current = resources;
    setOption(option);
  }, []);

  const handleBeforeDismiss = useCallback(() => {
    if (option) {
      navigate(SUPPORT_OPTION_CONFIG[option].destination, { state: { option, resources: resourcesRef.current } });
    }
  }, [option, navigate]);

  const handleDismiss = useCallback(() => setOption(null), []);

  const contextValue = useMemo(() => ({ showReassurance }), [showReassurance]);

  return (
    <SupportMomentsReassuranceContext.Provider value={contextValue}>
      {children}
      {option && <ReassuranceScreen option={option} onBeforeDismiss={handleBeforeDismiss} onDismiss={handleDismiss} />}
    </SupportMomentsReassuranceContext.Provider>
  );
};
